<script setup lang="ts">
defineOptions({ inheritAttrs: false });

const attrs = useAttrs();
const slots = useSlots();

const emit = defineEmits<{
  buttonAction: [];
}>();

const props = defineProps<{
  to?: string | null;
  icon?: string | null;
  iconColor?: string | null;
  iconMargin?: string;
  action?: () => unknown;
}>();

const busy = ref(false);

const isDisabled = computed(() => busy.value || Boolean(attrs.disabled));

const iconClasses = computed(() => {
  const margin = props.iconMargin ?? '1';
  const base = `fa-solid fa-${props.icon}`;
  const color = props.iconColor ? ` text-${props.iconColor}` : '';

  return slots.default ? `me-${margin} ${base}${color}` : `${base}${color}`;
});

const spinnerClasses = computed(() => {
  const base = 'spinner-border spinner-border-sm';

  return slots.default ? `me-${props.iconMargin ?? '1'} ${base}` : base;
});

const buttonAction = async () => {
  if (isDisabled.value) {
    return;
  }

  if (!props.action) {
    emit('buttonAction');

    return;
  }

  busy.value = true;

  try {
    await props.action();
  } finally {
    busy.value = false;
  }
};
</script>

<template>
  <nuxt-link v-if="to && !isDisabled" :to="to">
    <span class="btn" v-bind="$attrs" @click="buttonAction">
      <i v-if="icon" :class="iconClasses" />
      <slot />
    </span>
  </nuxt-link>
  <button
    v-else
    class="btn"
    type="button"
    v-bind="$attrs"
    :disabled="isDisabled"
    :aria-busy="busy"
    @click="buttonAction"
  >
    <span v-if="busy" aria-hidden="true" :class="spinnerClasses" />
    <i v-else-if="icon" :class="iconClasses" />
    <slot />
  </button>
</template>
